<script setup lang="ts">
import { useHead } from '@unhead/vue'
import { motion } from 'motion-v'

const { t } = useI18n()

useHead({
  link: [{
    rel: 'canonical',
    href: `${import.meta.env.VITE_MONOLITH_URL}/about-us`,
  }],
})

useSeoMeta({
  title: t('about.meta.title'),
  description: t('about.meta.description'),
  ogTitle: t('about.meta.title'),
  ogDescription: t('about.meta.description'),
  ogImage: `${S3_ASSETS_URL}/meta-default.jpg`,
})
</script>

<template>
  <div>
    <LayoutNavbar />

    <div class="mb-8 lg:mb-16">
      <div class="w-full bg-white pt-8 md:bg-[#f8f8f0]">
        <motion.h1
          class="mx-auto hidden max-w-screen-md text-balance text-center text-2xl !leading-tight md:block md:text-4xl"
          :initial="{
            opacity: 0,
            y: '10%',
          }"
          :while-in-view="{
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.4,
              ease: 'easeOut'
            }
          }"
        >
          {{ t('about.section.text_testimonials.title') }}
        </motion.h1>

        <AboutCarousel />
      </div>

      <AboutContent />
    </div>

    <LayoutFooter />
  </div>
</template>
